import React from "react";
import { Button } from "@vibe/core";

const ButtonComponent = ({ text, ...props }) => {
  return <Button {...props}>{text}</Button>;
};

export default ButtonComponent;
